import './App.css';

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Download from './pages/Download';
import Upload from './pages/Upload';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Upload />} />
          <Route path="/:code" element={<Download />} />
        </Routes>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
